// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, post, del } from "./api_client";
import { OperationMode } from "../models";
import { ChirpConfig, IChirpConfig, ChirpConfigTrackerConfigsResponse, IChirpConfigTrackerConfigsResponse } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function getChirpConfigEntity(id?: string): ApiResult<ChirpConfig> {
	return get<IChirpConfig>(`/api/chirpconfig/${ id }`).then(result => result === undefined ? undefined :  new ChirpConfig(result));
}

export async function getAll(): ApiResult<ChirpConfig[]> {
	return get<IChirpConfig[]>(`/api/chirpconfig`).then(result => result === undefined ? undefined : result.map(o => new ChirpConfig(o)));
}

export async function getByMode(mode: number): ApiResult<ChirpConfig[]> {
	return get<IChirpConfig[]>(`/api/chirpconfig/by-mode/${ mode }`).then(result => result === undefined ? undefined : result.map(o => new ChirpConfig(o)));
}

export async function getForDevice(deviceId?: string): ApiResult<ChirpConfig[]> {
	return get<IChirpConfig[]>(`/api/chirpconfig/for-device/${ deviceId }`).then(result => result === undefined ? undefined : result.map(o => new ChirpConfig(o)));
}

export async function save(chirpConfig: ChirpConfig): ApiResult<ChirpConfig> {
	return post<IChirpConfig>(`/api/chirpconfig`, chirpConfig).then(result => result === undefined ? undefined :  new ChirpConfig(result));
}

export async function getTrackerConfigs(id?: string): ApiResult<ChirpConfigTrackerConfigsResponse> {
	return get<IChirpConfigTrackerConfigsResponse>(`/api/chirpconfig/${ id }/tracker-configs`).then(result => result === undefined ? undefined :  new ChirpConfigTrackerConfigsResponse(result));
}

export async function deleteConfig(id?: string): ApiResult<undefined> {
	return del(`/api/chirpconfig/${ id }`);
}
